export function range(start: number, end: number) {
	const length = end - start + 1;
	return Array.from({ length }, (_, idx) => idx + start);
}
export function pagination(
	totalCount: number,
	pageSize: number,
	siblingCount: number,
	currentPage: number,
) {
	const DOTS = '...';
	const totalPageCount = Math.ceil(totalCount / pageSize);
	const totalPageNumbers = siblingCount + 5;

	if (totalPageNumbers >= totalPageCount) {
		return range(1, totalPageCount);
	}

	const leftSiblingIndex = Math.max(currentPage - siblingCount, 1);
	const rightSiblingIndex = Math.min(currentPage + siblingCount, totalPageCount);

	const shouldShowLeftDots = leftSiblingIndex > 1;
	const shouldShowRightDots = rightSiblingIndex < totalPageCount;

	const firstPageIndex = 1;
	const lastPageIndex = totalPageCount;

	if (!shouldShowLeftDots && shouldShowRightDots) {
		const leftItemCount = 1 + 2 * siblingCount;
		const leftRange = range(1, leftItemCount);

		return [...leftRange, DOTS, totalPageCount];
	}
	if (shouldShowLeftDots && !shouldShowRightDots) {
		const rightItemCount = 1 + siblingCount;
		const rightRange = range(totalPageCount - rightItemCount, totalPageCount);

		return [firstPageIndex, DOTS, ...rightRange];
	}
	if (shouldShowLeftDots && shouldShowRightDots) {
		const middleRange = range(leftSiblingIndex, rightSiblingIndex);
		return [firstPageIndex, DOTS, ...middleRange, DOTS, lastPageIndex];
	}
}
